import Navbar from "@/components/Navbar";

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Vilkår for bruk</h1>
        <p className="text-sm text-gray-500 mb-8">Sist oppdatert: 1. juli 2025</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Om tjenesten</h2>
          <p className="text-gray-600">
            VeiKlar er en digital læringsplattform for norsk teoriprøve (klasse B).
            Tjenesten tilbyr øvingsoppgaver, forklaringer og læremateriell.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Kjøp og tilgang</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li>Tilgang kjøpes med en engangsavgift – ingen abonnement, ingen utløpsdato</li>
            <li>Betaling skjer via Vipps eller kort (Stripe)</li>
            <li>Tilgang aktiveres umiddelbart etter bekreftet betaling</li>
            <li>Prisen er oppgitt i norske kroner (NOK) inkl. MVA</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Angrerett</h2>
          <p className="text-gray-600">
            Du har 14 dagers angrerett i henhold til angrerettloven. Dersom du har
            brukt tjenesten (påbegynt kurs eller quiz), bortfaller angreretten.
            For å benytte angreretten, kontakt oss på{" "}
            <a href="mailto:hei@veiklar.no" className="text-fjord underline">hei@veiklar.no</a>{" "}
            innen 14 dager fra kjøpsdato.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Brukerkonto</h2>
          <ul className="list-disc pl-6 text-gray-600 space-y-1">
            <li>Kontoen er personlig og kan ikke deles</li>
            <li>Du er ansvarlig for aktivitet på din konto</li>
            <li>Vi kan stenge kontoer som misbrukes</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Ansvarsbegrensning</h2>
          <p className="text-gray-600">
            VeiKlar er et læringsverktøy og garanterer ikke bestått teoriprøve.
            Innholdet er ment som supplement til offisielle lærebøker og trafikkskoleopplæring.
            Vi er ikke ansvarlige for feil i Statens vegvesens offisielle spørsmålsbank.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Immaterielle rettigheter</h2>
          <p className="text-gray-600">
            Alt innhold på VeiKlar (tekst, illustrasjoner, design) tilhører VeiKlar
            og er beskyttet av opphavsretten. Det er ikke tillatt å kopiere eller
            videredistribuere innholdet.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Endringer</h2>
          <p className="text-gray-600">
            Vi kan oppdatere disse vilkårene. Vesentlige endringer varsles per e-post
            minst 14 dager i forveien.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Lovvalg og verneting</h2>
          <p className="text-gray-600">
            Norsk rett gjelder. Tvister søkes løst i minnelighet. Verneting er Oslo tingrett.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">9. Kontakt</h2>
          <p className="text-gray-600">
            VeiKlar · <a href="mailto:hei@veiklar.no" className="text-fjord underline">hei@veiklar.no</a>
          </p>
        </section>
      </main>
    </div>
  );
}
